import React from 'react';
import ReactDOM from 'react-dom';
import getHistory from './util/app_history';
import { Router, Route, Redirect, Switch } from 'react-router-dom';

import Layout from './components/common/layout';
import AuthLayout from './components/common/auth_layout';
import Terms from './components/terms';
import ForgotPassword from './components/common/forgot_password';
import ResetPassword from './components/common/reset_password';
import MediaKit from './components/company/media_kit';
import OptOut from './components/respondent/opt_out';

const start = () => {
  const history = getHistory();

  try {
    window.analytics.page();
  } catch (e) {
    // do nothing with the error here
  }
  ReactDOM.render((
    <Router history={history}>
      <Switch>
        <Route path={['/forgotpassword', '/misc/reset']}>
          <AuthLayout>
            <Route path="/misc/reset" component={ResetPassword} />
            <Route path="/forgotpassword" component={ForgotPassword} />
          </AuthLayout>
        </Route>
        <Route path={[
          '/misc/forgot', '/company/mediakit', '/referral',
          '/respondent/opt-out', '/terms/:type',
          ]}>
          <Layout>
            <Switch>
              <Route path="/misc/forgot" component={ForgotPassword} />

              <Route path="/company/mediakit" component={MediaKit} />

              <Route path="/respondent/opt-out" component={OptOut} />

              <Route path="/terms/:type" component={Terms} />
            </Switch>
          </Layout>
        </Route>
      </Switch>
    </Router>),
    document.getElementById('content')
  );
};

export default { start };

